
import $ from 'jquery';
import {parsePhoneNumber} from './../general/PhoneHelper.js';
import * as Errors from './../general/Error.js';

class BulkyGoodsPopup {

    constructor( popup ) {

        this.$popup = $( popup );

        this.$form = this.$popup.find( '#form_bulky_goods_update_phone' );
        this.$form.on( 'submit', ( ev ) => this.onSubmit( ev ) );

        // Fix Errors.
        this.$form.find( '#nummer_tel' ).on( 'input', () => this.removeError() );

        // Format Number.
        this.$form.find( '#nummer_tel' ).on( 'input', () => this.formatInput() );
    }

    addError = () => {
        const $input = this.$form.find( '#nummer_tel' );
        Errors.showError( $input );
    }

    removeError = () => {
        const $input = this.$form.find( '#nummer_tel' );
        Errors.hideError( $input );
    }

    formatInput = ( ev ) => {
        const $input = this.$form.find( '#nummer_tel' );

        return $.when( parsePhoneNumber( $input.val() ) )
        .then( ( response ) => {

            const parsed = response.getNumber();
            if ( 'undefined' === typeof parsed || ! parsed.isValid() ) {

            } else {
                $input.val( parsed.formatInternational() );
            }
        });
    }

    onSubmit = ( ev ) => {
        // Prevent normal submit, because we only do AJAX.
        ev.preventDefault();
        this.removeError();

        const $input = this.$form.find( '#nummer_tel' );

        return $.when(parsePhoneNumber( $input.val() ) )
        .then( ( response ) =>  {

            const parsed = response.getNumber();
            if ( 'undefined' === typeof parsed || ! parsed.isValid() ) {

                this.addError();
                return false;
            } else {

                const url = this.$form.attr( 'data-update-url' ) || '/index.php?cl=user&fnc=updateCustomerPhone';

                // Format input value - then update.
                $input.val( parsed.formatInternational() );
                return $.ajax({
                    method: 'GET',
                    url: url,
                    data: {
                        phonenumber: parsed.formatInternational()
                    }
                }).promise();
            }
        }).then( ( success ) => {
            if ( success ) {
                ev.currentTarget.submit();
            }
        })
    }

    /**
     * Test whether we need to display popup.
     *
     * @return boolean
     */
    phoneNumberNeedsUpdate = () => {
        const nophonenumber = $('#nouseroxfon').val();
        const paymentType = $('#payment_type').val();

        return nophonenumber && paymentType !== 'oxkas';
    }

    /**
     * Open Bulky Goods Popup.
     */
    open = () => {
        EN_KO.functions.setLoading( false );
        return EN_KO.functions.open_popup( this.$popup );
    }

    /**
     * Close Bulky Goods Popup again.
     */
    close = () => {
        return EN_KO.functions.close_popup( this.$popup );
    }
}


$( document ).ready( function() {

    // Get Popup.
    const $popup = $( '#popup_bulky_goods_prompt_for_phone' );
    if ( $popup.length <= 0 ) {
        return;
    }

    // Create Instance Handler.
    const PopupHandler = new BulkyGoodsPopup( $popup );

    // If the user still hasn't entered his phone, we stop the submit.
    $('#orderConfirmAgbTop,#orderConfirmAgbBottom').on( 'submit', function( ev ) {
        if ( PopupHandler.phoneNumberNeedsUpdate() ) {
            ev.preventDefault();
            PopupHandler.open();
        }
    });

    // Open on load already, so the user immediately knows.
    // This is needed for PayPalExpress.
    if ( PopupHandler.phoneNumberNeedsUpdate() ) {
        PopupHandler.open();
    }
} );
